<template>
	<div
		class="parent"
		:style="{
			'background-image':
				'linear-gradient(rgba(0, 0, 0, 0.3), rgb(0, 0, 0)),url(' + bgImg + ')',
		}"
	>
		<div class="forgotpassword-container">
			<div class="forgotpassword-content-container">
				<div>
					<h2 class="forgotpassword-title">
						<a>Forgot password</a>
					</h2>
					<h3 class="forgotpassword-text"></h3>
				</div>
				<div class="forgotpassword-form-container">
					<form>
						<label class="login-lable">Email address</label>
						<input
							type="email"
							v-model="userid"
							placeholder="Enter your email address"
							id="login-input"
							autofocus
						/>
						<a
							@click="forgotpassword"
							type="submit"
							class="forgotpassword-button"
							data-background-color="#ad03ff"
							:class="{ active: isActive }"
							>Send forgot Link</a
						>
						<label
							class="forgotpassword-lable"
							style="width:100%;text-align: center;"
							v-if="showforgotpasswordErr"
							>{{ forgotpasswordErr }}</label
						>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.text-href {
	text-decoration: none;
	color: #fff;
	cursor: pointer;
}
.parent {
	position: relative;
	height: 100vh;
	width: 100%;
	margin-top: 70px;
}
.forgotpassword-container {
	padding: 2rem !important;
	margin: 0 auto;
	background: #4c4c4c;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	min-width: 30%;
	max-width: 30%;
	font-size: 18px;
	border-radius: 10px;
	border-radius: 10px;
}

.forgotpassword-button {
	margin-bottom: 1.75rem !important;
}

.forgotpassword-content-container .forgotpassword-button {
	-webkit-appearance: none;
	display: inline-block;
	background-color: #d81f26;
	text-align: center;
	width: 100%;
	border: 1px solid #d81f26;
	padding: 10px;
	border-radius: 5px;
	font-weight: 500;
	font-size: 16px;
	position: relative;
	transition: all 0.2s ease-out;
	padding: 11px 0px 10px 0px;
	cursor: pointer;
}
.forgotpassword-button.active {
	opacity: 0.7;
}
.forgotpassword-button:hover {
	opacity: 0.8;
}

.forgotpassword-title {
	font-weight: 700;
	line-height: 1.2em;
	text-align: center !important;
	color: #fff;
	text-shadow: 1px 1px 5px #333;
}

.forgotpassword-text {
	color: #fff;
	text-shadow: 1px 1px 5px #333;
	text-align: center !important;
	font-weight: 500;
}

.forgotpassword-form-container {
	box-sizing: inherit;
}
.forgotpassword-lable {
	cursor: pointer;
	display: block;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	float: left;
	color: #fff;
	text-shadow: 1px 1px 5px #333;
}

#forgotpassword-input {
	height: 2.5rem;
	width: 100%;
	padding: 0.375rem 0.9375rem;
	color: #8699a6;
	font-size: 0.875rem;
	background-color: #fff;
	border: 1px solid #b3bfc8;
	margin-bottom: 1rem;
	box-shadow: none;
	box-sizing: border-box;
	border-radius: 3px;
	-webkit-transition: border 0.2s ease;
	transition: border 0.2s ease;
}

@media only screen and (max-width: 900px) {
	.forgotpassword-container {
		position: relative;
		min-width: 60%;
		max-width: 60%;
		top: 50%;
		left: 0%;
		transform: translate(0%, -50%);
	}
}
</style>

<script>
export default {
	name: "forgotpassword",
	components: {},

	methods: {
		gotoSingin() {
			this.$router.push("/signup");
		},
		forgotpassword() {
			this.isActive = true;
			this.showforgotpasswordErr = false;

			if (this.doforgotpassword) {
				var dataToSend = {
					id: this.userid,
				};
				var self = this;
				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("forgetpassword", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setLoader", false);
							self.showforgotpasswordErr = true;
							self.forgotpasswordErr = res.message;
							setTimeout(function() {
								self.$router.push({ name: "login" });
							}, 10000);
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showforgotpasswordErr = true;
						this.forgotpasswordErr = err.response.data.error.message;
					});
			}
		},
	},

	data() {
		return {
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
